var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 16C11.4477 16 11 15.5523 11 15V7.85L9.11962 9.73038C8.72425 10.1258 8.0761 10.1145 7.68772 9.71228C7.30886 9.31989 7.30912 8.69088 7.69481 8.30519L11.2929 4.70711C11.6834 4.31658 12.3166 4.31658 12.7071 4.70711L16.3052 8.30519C16.6909 8.69088 16.6911 9.31989 16.3123 9.71228C15.9239 10.1145 15.2758 10.1258 14.8804 9.73038L13 7.85V15C13 15.5523 12.5523 16 12 16ZM6 20C5.45 20 4.979 19.804 4.587 19.412C4.195 19.02 3.99934 18.5493 4 18V16C4 15.4477 4.44772 15 5 15C5.55229 15 6 15.4477 6 16V18H18V16C18 15.4477 18.4477 15 19 15C19.5523 15 20 15.4477 20 16V18C20 18.55 19.804 19.021 19.412 19.413C19.02 19.805 18.5493 20.0007 18 20H6Z",
    fill: "#6D757D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpload);
export default __webpack_public_path__ + "static/media/icon-upload.9a713f503e2a90270dc9e428543e812c.svg";
export { ForwardRef as ReactComponent };